<template>
	<div class="incenters">
		<!-- style="border: 1px solid red;" -->
		<div>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Expost"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div>
			<Commontable :loadingTable="loading" @onRowClick="onRowClick" colnum=7 :tableData="tableData"
				:headerData="headerData" height="100%"></Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

	</div>
</template>

<script>
	import Commontable from '../../../components/common-table.vue'
	import Commonbtn from '../../../components/common-btn.vue'
	import Pagination from '../../../components/pagination.vue'
	import {
		AsnInfo,
		AsnDetail,
		AsnUnique,
		AsnExpost,
		InventoryClassList,
		ASNVoucherType
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			},
			loading: {
				type: Boolean,
				default: true
			}
		},
		data: function() {
			return {
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50
					},
					{
						prop: 'StatusName',
						label: '状态',
						columnwidth: 90
					},
					{
						prop: 'VouCode',
						label: '经销商入库',
						columnwidth: 130
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 150
					},
					{
						prop: 'Organization',
						label: '一级经销商编号',
						columnwidth: 120
					},
					{
						prop: 'CompanyName',
						label: '一级经销商名称 ',
						columnwidth: 120
					},
					{
						prop: 'CusCode',
						label: '经销商编号',
						columnwidth: 100
					},
					{
						prop: 'CusName',
						label: '经销商名称',
						columnwidth: 130
					},
					{
						prop: 'WHCode',
						label: '仓库编号',
						columnwidth: 80
					},
					{
						prop: 'WHName',
						label: '仓库名称',
						columnwidth: 180
					},
					{
						prop: 'VoucherType',
						label: '单据类型',
						columnwidth: 110
					},
					{
						prop: 'OrgCode',
						label: '经销商订单号',
						columnwidth: 150
					},
					{
						prop: 'OuterCode',
						label: '外部单据号',
						columnwidth: 140
					},
					{
						prop: 'Remark',
						label: '备注',
						columnwidth: 150
					},
					{
						prop: 'OWhName',
						label: '调出公司',
						columnwidth: 130
					},
					{
						prop: 'SourceTypeName',
						label: '单据来源',
						columnwidth: 130
					},
					{
						prop: 'Total',
						label: '总金额',
						columnwidth: 80
					}, {
						prop: "DamageCode",
						label: "报损出库单号",
						columnwidth: 150,
					},
					{
						prop: "BuyerName",
						label: "报损付款方",
						columnwidth: 200,
					},
					{
						prop: "TerminalHPName",
						label: "报损终端医院",
						columnwidth: 200,
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 130
					},
					{
						prop: 'CreateTime',
						label: '创建时间',
						columnwidth: 130
					},
					{
						prop: 'UpdaterName',
						label: '修改人',
						columnwidth: 130
					},
					{
						prop: 'UpdateTime',
						label: '修改时间',
						columnwidth: 130
					},
					{
						prop: 'VerifierName',
						label: '审核人',
						columnwidth: 150
					},
					{
						prop: 'VerifyTime',
						label: '审核时间',
						columnwidth: 150
					},
				],
			}
		},
		mounted() {

		},
		methods: {
			Expost() {
				this.$emit('Expost')
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			onRowClick(val) {
				//console.log(val, "val")
				this.$emit('onRowClick', val)
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		div {
			margin-left: 8px;
			margin-right: 8px;
			margin-top: 5px;
			margin-bottom: 5px;
		}
	}
</style>